<template lang="pug">
  .partner-logo(v-if="logo")
    img(:src="logo" :alt="`Logo Parceiro ${name}`")
</template>

<script>
export default {
  name: 'PartnerLogo',
  props: {
    name: {
      type: String,
      required: true
    },
    logo: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .partner-logo{
    text-align: center;
    margin-top: 30px;

    img{
      height: 70px;
      max-width: 100%;
    }
  }
</style>
